import React from 'react'
import IntlMessages from 'util/IntlMessages'
import { Card } from 'antd'

const ZakatBankAccount1 = () => {
	return (
		<Card bordered={true} bodyStyle={{ padding: 0 }}>
			<div className='gx-user-wid-row' style={{ backgroundColor: '#008E480D' }}>
				<div className='gx-mr-3'>
					<Card
						className='gx-assunnah-bank-account'
						bordered={true}
						bodyStyle={{ padding: 0 }}
					>
						<img
							alt='Bank Icon 2'
							src={require('assets/images/bank-icon-2.svg')}
						/>
					</Card>
				</div>
				<div className='gx-user-wid-body gx-py-3 gx-pr-3'>
					<div className='ant-row-flex'>
						<h2 className='h4 gx-mr-1 gx-mb-1'>
							<Card
								bordered={false}
								bodyStyle={{ padding: 0 }}
								style={{ margin: 0, backgroundColor: '#008E4800' }}
							>
								<IntlMessages id={'donation.product.zakat.bank.account.name'} />{' '}
								As sunnah Foundation Zakat Fund
								<br />
								<IntlMessages
									id={'donation.product.zakat.bank.account.no'}
								/>{' '}
								07511100103026
								<br />
								<IntlMessages id={'donation.product.zakat.bank.name'} /> Exim
								Bank Ltd.
								<br />
								<IntlMessages
									id={'donation.product.zakat.bank.branch.name'}
								/>{' '}
								Satarkul, Badda, Dhaka
								<br />
								<IntlMessages
									id={'donation.product.complex.bank.routing.no'}
								/>{' '}
								100264025
							</Card>
						</h2>
					</div>
				</div>
			</div>
		</Card>
	)
}

export default ZakatBankAccount1
